import {
  Box,
  Breadcrumbs,
  Button,
  Container,
  Grid,
  Link,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SortIcon from "@mui/icons-material/Sort";
import ProductCard from "../Components/Products/ProductCard";
import API from "../utils/API";
import { Helmet } from "react-helmet";

const ProductsByBrand = () => {
  let { brandID } = useParams();

  const navigate = useNavigate();

  const [activeBrand, setActiveBrand] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [products, setProducts] = useState([]);
  const [brands, setBrands] = useState([]);
  const [next, setNext] = useState(null);
  const [totalProducts, setTotalProducts] = useState(0);
  const [currentProducts, setCurrentProducts] = useState(0);
  const [isLoading, setLoading] = useState(false);
  // ✅ Default value "Default" हटा दिया गया है, अब यह null से शुरू होगा
  const [selectedSort, setSelectedSort] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // ✅ fetchProducts से मूल डेटा को स्टोर करने के लिए एक नई state
  const [originalProducts, setOriginalProducts] = useState([]);

  const handleSort = (sortType) => {
    setSelectedSort(sortType);
    setAnchorEl(null);
    let sortedProducts = [...products];

    if (sortType === "Price: Low to High") {
      sortedProducts.sort(
        (a, b) => parseFloat(a.price_unit) - parseFloat(b.price_unit)
      );
    } else if (sortType === "Price: High to Low") {
      sortedProducts.sort(
        (a, b) => parseFloat(b.price_unit) - parseFloat(a.price_unit)
      );
    }
    // ✅ "Default" हटा दिया गया है, इसलिए 'else' ब्लॉक को हटाया गया
    // यदि आप सॉर्टिंग हटाना चाहते हैं, तो आप products को originalProducts पर सेट कर सकते हैं:
    // else if (sortType === null) {
    //   setProducts(originalProducts);
    // }

    // केवल तभी सेट करें जब कोई सॉर्टिंग लागू हो (null/Default के लिए कोई बदलाव नहीं होगा,
    // और यह पिछले सॉर्ट किए गए या मूल क्रम को बनाए रखेगा)
    setProducts(sortedProducts);
  };


  useEffect(() => {
    fetchBrands();
    fetchProducts();
  }, [brandID]);

  const fetchBrands = async () => {
    const res = await API({
      method: "GET",
      url: "brand/",
    });
    setBrands(res.filter((item) => item.web === true));
  };

  const fetchProducts = async () => {
    const _brand = await API({
      method: "GET",
      url: `brand_slug/${brandID}`,
    });
    setActiveBrand(_brand);
    const res = await API({
      method: "GET",
      url: `product/?brand=${_brand.id}`,
    });
    setProducts(res.results);
    // ✅ मूल डेटा को भी स्टोर करें ताकि अगर user को कोई सॉर्ट नहीं चाहिए तो इसे बहाल किया जा सके
    setOriginalProducts(res.results); 
    setTotalProducts(res.count);
    setCurrentProducts(res.results.length);
    setNext(res.next);
    // जब भी नए प्रॉडक्ट्स fetch हों तो सॉर्टिंग को हटा दें (या null सेट करें)
    setSelectedSort(null); 
  };

  const loadMore = async () => {
    setLoading(true);
    const res = await API({
      method: "GET",
      url: next,
    });
    setProducts([...products, ...res.results]);
    setOriginalProducts([...originalProducts, ...res.results]); // Original में भी जोड़ें
    setCurrentProducts(currentProducts + res.results.length);
    setNext(res.next);
    setLoading(false);
    // ध्यान दें: loadMore के बाद, सॉर्ट किए गए प्रॉडक्ट्स में नए प्रॉडक्ट्स 'products' के अंत में जुड़ जाएंगे 
    // और फिर से सॉर्ट नहीं होंगे जब तक कि user नया सॉर्ट विकल्प न चुने।
  };

  const renderBrandDescription = () => {
    const description = activeBrand?.description;
    const hasDescription = description && description.trim().length > 0;

    if (!hasDescription) {
      return null;
    }

    return (
      <Container maxWidth="lg" sx={{ mt: 5, mb: 8 }}>
        <Box
          dangerouslySetInnerHTML={{ __html: description }}
          sx={{
            mx: { xs: 1, sm: 0 },
            '& h1, & h2, & h3, & h4, & h5, & h6': {
              mt: 0.5,
              mb: 0.5,
              color: 'primary.dark',
              fontWeight: 700,
            },
            '& p': {
              mb: 0.5,
              lineHeight: 1.6,
              fontSize: { xs: '0.9rem', sm: '1rem' }
            },
            '& a': {
              color: 'secondary.main',
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'underline',
              },
            }
          }}
        />
      </Container>
    );
  };


  return (
    <>
      <Helmet>
        <title>{activeBrand?.meta_title || "NMP Pharmacy"}</title>
        <meta name="description" content={activeBrand?.meta_description} />
        <link
          rel="canonical"
          href={`https://nmp.com.pk/brand/${activeBrand?.slug}`}
        />
      </Helmet>
      {/* Box marginX={5} poore page ko side margin de raha hai */}
      <Box marginX={5}>
        {activeBrand.banner && (
          <img
            src={activeBrand?.banner}
            alt={activeBrand?.name}
            style={{
              width: "100%",
              height: "auto",
              maxHeight: "400px",
              objectFit: "cover",
              display: "block",
            }}
          />
        )}
        
        {/* Breadcrumbs aur Sort Button ko ek hi line mein dikhana */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ mt: 2, mb: 2 }} // Spacing add kiya
        >
          <Breadcrumbs
            sx={{
              // mt: 2, // Original mt:2 yahan tha, ab Stack mein adjust kiya
            }}
          >
            <Link underline="hover" color="inherit" href="/">
              Home
            </Link>
            <Typography color="text.primary">
              {activeBrand.name}
            </Typography>
          </Breadcrumbs>

          {/* New Sort Button on Right Side */}
          <Box>
            <Button
              aria-controls={open ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
              startIcon={<SortIcon />}
              variant="outlined"
              size="small"
              sx={{ minWidth: 150 }}
            >
              {/* ✅ "Default" की जगह पर null होने पर 'Sort By' या कोई अन्य टेक्स्ट दिखाएं */}
              Sort: {selectedSort || "Select Option"}
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
            >
              {/* ✅ Default Sort option हटा दिया गया है */}
              
              {/* Low to High Sort */}
              <MenuItem 
                onClick={() => handleSort("Price: Low to High")}
                selected={selectedSort === "Price: Low to High"}
              >
                Price: Low to High
              </MenuItem>
              {/* High to Low Sort */}
              <MenuItem 
                onClick={() => handleSort("Price: High to Low")}
                selected={selectedSort === "Price: High to Low"}
              >
                Price: High to Low
              </MenuItem>
              
            </Menu>
          </Box>
        </Stack>

        {/* Product Grid Container - Ab poori width use karega */}
        <Grid container spacing={2} sx={{ mt: 2 }}>
          {/* LEFT SIDEBAR HATA DIYA GAYA HAI */}
          
          {/* Product Listing Area - Ab poori 12 column width use karega */}
          <Grid item xs={12}> 
            <Grid
              container
              spacing={2} // Grid items ke beech ki spacing
              sx={{
                mt: { xs: 2, md: 0 },
                mb: 5,
              }}
            >
              {products.map((product) => (
                <Grid item xs={12} sm={6} md={4} lg={2.4} key={product.id}> 
                  <ProductCard
                    product={product}
                    breadcrumb={
                      brands?.find((brand) => brand.id === parseInt(brandID))
                        ?.name
                    }
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>

        {isLoading && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mt: 2,
            }}
          >
            <Box
              component={"img"}
              src={require("../Assets/images/loader.gif")}
              height={100}
              width={300}
              style={{
                objectFit: "cover",
              }}
              sx={{
                mt: 2,
                mb: 5,
              }}
              alt={"loading"}
            />
          </Box>
        )}

        {next && !isLoading && (
    <Stack
        // ✅ Stack Container: Minimal vertical margin (mt: 3, mb: 5)
        sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            mt: 0, 
            mb: 3, 
            // Optional: Slight background for separation without shadow
            p: 2, 
            backgroundColor: 'action.hover', // Very light/subtle background
            borderRadius: 1, 
        }}
    >
        {/* ✅ Products Count Typography: Simple and focused */}
        <Typography
            variant="body1" // Standard body font size
            sx={{
                mb: 1.5, // Reduced margin
                color: 'text.primary',
                fontWeight: 500,
            }}
        >
            You've viewed {currentProducts} of {totalProducts} products.
        </Typography>

        {/* ✅ Progress Bar: Thinner and centered */}
        <Box 
            sx={{ 
                width: '100%', 
                maxWidth: 350, // Max width set
                backgroundColor: 'grey.300', // Light grey track
                borderRadius: 5, 
                overflow: 'hidden', 
                mb: 3, // Minimal margin below the bar
            }}
        >
            {/* Progress Indicator */}
            <Box
                sx={{
                    // Percentage calculation
                    width: `${(currentProducts / totalProducts) * 100}%`,
                    height: 6, // ✅ Thinner bar
                    backgroundColor: 'primary.main', // Using primary color (often a blue/red)
                    transition: 'width 0.4s ease-out', 
                }}
            />
        </Box>

        {/* ✅ Load More Button: Standard size, subtle hover */}
        <Button
            variant="outlined" // ✅ Outlined (less heavy) variant for aesthetic
            color="primary"
            onClick={loadMore}
            sx={{ 
                height: 40, // Slightly reduced height
                width: '100%',
                maxWidth: 200, // Reduced width for focus
                fontSize: '0.9rem',
                fontWeight: 600,
                // Subtle lift on hover
                '&:hover': {
                    transform: 'translateY(-1px)',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                },
                borderRadius: 1, // Square edges for modern look (or 50 for pill)
            }}
        >
            Load More Products
        </Button>
    </Stack>
)}

        {/* Description Section */}
        {Object.keys(activeBrand).length > 0 && renderBrandDescription()}
        
      </Box>
    </>
  );
};

export default ProductsByBrand;